import { api_base } from '../api';
import { toast } from '../../scripts/toast';
import { logoutUser } from '../actions';

export const WishList = {
	// ----- GET (CURRENT USER) -----

	get(user, cb) {
		$.ajax({
			url: api_base + '/users/favorites/me',
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ----- ADD -----

	add(user, product, cb) {
		if (!user.token) {
			return toast({
				title: 'Favoritos',
				content: 'Inicia sesión para agregar a favoritos'
			});
		}

		$.ajax({
			url: api_base + '/users/favorites/me/put/' + product.id,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Favoritos',
					content: 'El producto ' + product.name + ' fue agregado.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					return toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				toast({
					title: 'Favoritos',
					content: 'Error al agregar un favorito.'
				});
				// console.log(err);
			}
		});
	},

	remove(data, product, cb) {
		if (!data.token) {
			return toast({
				title: 'Favoritos',
				content: 'Inicia sesión para eliminar de favoritos'
			});
		}
		
		$.ajax({
			url: api_base + '/users/favorites/me/remove/' + product.id,
			method: 'DELETE',
			headers: {
				Authorization: 'Bearer ' + data.token
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Favoritos',
					content: 'El producto ' + product.name + ' fue removido.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					return toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				toast({
					title: 'Favoritos',
					content: 'Error al eliminar un favorito.'
				});
				// console.log(err);
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/store/api/wish_list.js